module.exports = __webpack_public_path__ + "static/media/maria2.aa9504ed.png";